export enum List_Wrap {
    FALSE,
    AFTER_FIRST_EL,
    AFTER_SECOND_EL,
    AFTER_THIRD_EL,
}
